import { GridSortDirection } from '../enums';

export interface SortDescriptor<T> {
  columnDef: keyof T;
  direction: GridSortDirection;
  sortValueAccessor?: (columnDef: keyof T, data: T) => any;
}
